/**
 * `WhyTabItem` is a presentational component for a single "Why" list item.
 *
 * It displays an icon, a title, and a description, and uses `index` to provide
 * a stable icon alt label.
 */
import React from 'react';

import { WhySectionListItemCustomisation } from '../../../common/CommonTypes';

export type WhyTabPanel = {
  iconSrc: string;
  iconAlt: string;
  panelTitleText: string;
  panelDetailText: string;
};

type WhyTabItemProps = {
  panel: WhySectionListItemCustomisation;
  index: number;
};

const WhyTabItem = ({ panel, index }: WhyTabItemProps): JSX.Element => {
  const {
    whySectionItemTitle,
    whySectionItemDescription,
    whySectionItemLogoUrl
  } = panel;

  const getAlt = () => {
    return 'icon-' + index;
  };

  return (
    <div className='flex-column why--item'>
      <img className='icon-style' src={whySectionItemLogoUrl} alt={getAlt()} />
      <h3 className='lp-why-item-header'>{whySectionItemTitle}</h3>
      <p>{whySectionItemDescription}</p>
    </div>
  );
};

export default WhyTabItem;
